<template>
<div class="act-wrap">
    <div class="email-inner" v-if="wayType==='email'">
        <div class="notice">
            {{ $t($loginLangPrefix('userSign.actemail'), {name: this.name}) }}
        </div>
        <div class="btn sure" :class="{act: act}" @click="register()">{{ $t($loginLangPrefix('userSign.complatereg')) }}</div>
        <div class="btn resend" :class="{act: act}" @click="resend()">{{ $t($loginLangPrefix('userSign.resend')) }}</div>
        <toast-pop v-show="toastState" :txt="txt"/>
    </div>
    <div class="memail-inner" v-if="wayType==='m-email'">
        <div class="title">{{ $t($loginLangPrefix('userSign.signUp')) }}</div>
        <div class="notice mb">
            {{ $t($loginLangPrefix('userSign.actemail'), {name: this.name}) }}
        </div>
        <div class="btn sure mb" :class="{act: act}" @click="register()">{{ $t($loginLangPrefix('userSign.complatereg')) }}</div>
        <div class="btn resend mb" :class="{act: act}" @click="resend()">{{ $t($loginLangPrefix('userSign.resend')) }}</div>
        <toast-pop v-show="toastState" :txt="txt" mb="mb" />
    </div>
</div>
</template>
<script>

import toast from '../common/toast';
import api from '../js/api';
import logreg from '../js/logreg';

export default {
    name: 'actwrap',
    props: {
        name: { type: String, default: '' },
        token: { type: String, default: '' },
        wayType: { type: String, default: '' }
    },
    data() {
        return {
            password: '',
            code: '',
            act: false,
            toastState: false,
            txt: 'You are not certified'
        };
    },
    components: {
        'toast-pop': toast
    },
    methods: {
        register() {
            api.isActiveEmail(this.token).then((data) => {
                if (data.ret === '1' && data.data && data.data.is_active === '0') {
                    // {{ $t($loginLangPrefix('userSign.notActive')) }}
                    this.showPop(this.$t(this.$loginLangPrefix('userSign.notActive')));
                } else {
                    // 登录 accessToken, regType, keep = 0, callback
                    logreg.userInfo(this.token, logreg.REGTYPE.email, 1, (state, udata) => {
                        if (state === 'success') {
                            this.$emit('success', udata);
                        } else if ((window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(`${udata.status}`) >= 0) || (window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(udata.data && `${udata.data.status}`) >= 0)) {
                            // this.showPop(this.$t(this.$loginLangPrefix('userSign.fkError')));
                        } else if (data.errorMessageTMXTip) {
                            //
                        } else {
                            this.showPop(this.$t(this.$loginLangPrefix('userSign.sysError')));
                        }
                    }, this.name);
                }
            }).catch((response) => {
                console.log(response);
            });
        },
        resend() {
            api.sendEmail(this.name, 0, this.token).then(() => {
                this.showPop(this.$t(this.$loginLangPrefix('userSign.emailsended')));
            }).catch((response) => {
                console.log(response);
            });
        },
        showPop(txt) {
            this.txt = txt;
            this.toastState = true;
            setTimeout(() => {
                this.txt = '';
                this.toastState = false;
            }, 1500);
        }
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.act-wrap {
    position: relative;
    width: 100%;
    .memail-inner {
        .title {
            position: relative;
            margin-top: rem(80);
            width:100%;
            font-size:24px;
            font-family: 'RobotoMedium';
            font-weight:800;
            color:rgba(23,23,23,1);
            line-height:rem(29);
            height: rem(29);
        }
    }
    .notice {
        width:100%;
        height:44px;
        font-size:15px;
        font-family: 'RobotoRegular';
        font-weight: normal;
        color:rgba(23,23,23,1);
        line-height:22px;
        margin-bottom: 25px;
        word-break: break-all;
        &.mb {
            height:rem(44);
            font-size:15px;
            line-height:rem(22);
            margin-bottom: rem(25);
            margin-top: rem(5);
            color:rgba(153,153,153,1);
        }
    }
    .btn {
        position: relative;
        margin-top: 40px;
        width:100%;
        height:48px;
        border-radius:24px;
        font-size:16px;
        font-family: 'RobotoMedium';
        font-weight:600;
        text-align: center;
        line-height:48px;
        cursor: pointer;
        transition: background linear .1s;
    }
    .sure {
        color:rgba(255,255,255,1);
        background:rgba(157,29,255,1);
        &.mb {
            margin-top: rem(40);
            height: rem(48);
            border-radius: rem(24);
            line-height: rem(48);
        }
    }
    .resend {
        margin-top: 20px;
        color:rgba(157,29,255,1);
        border:1px solid rgba(157,29,255,1);
        &.mb {
            margin-top: rem(20);
            height: rem(48);
            border-radius: rem(24);
            line-height: rem(48);
        }
    }
}
</style>
